import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import classnames from "classnames";
import * as notify from "../../../shared/notify";

import { charactersOnly } from "../../../shared/spell-check";

function buildOutputFromObject(obj) {
    if (obj && obj.uom) {
        return `${obj.value} ${obj.uom.text}`;
    }
}

function getTextfromObject(obj) {
    return obj && obj.uom ? obj.uom.text : "";
}

export const SelectedItem = (props) => {
    const { disabled, index, isEditable, value, text, removeValue, updateValues } = { ...props };
    const [inputValue, setInputValue] = useState(text);
    const [isEdited, setIsEdited] = useState(false);

    const handleClick = () => {
        removeValue(index);
    };
    const updateField = (e) => {
        const newValue = e.currentTarget.value;
        setInputValue(newValue);
        setIsEdited(true);
    };
    const saveValue = () => {
        if (isEdited) {
            if (!inputValue) {
                notify.error("Value can not be emtpy.");
                setInputValue(text);
                setIsEdited(false);

                return;
            }

            updateValues(index, inputValue);
            setIsEdited(false);
        }
    };

    let readOnlyOutput = !isEditable ? (typeof text === "object" ? buildOutputFromObject(inputValue) : inputValue) : null;
    let warnSpelling = false;
    const valueAlphaOnly = typeof text === "object" ? getTextfromObject(inputValue) : charactersOnly(inputValue);
    props.spellingErrors.forEach((e) => {
        if (valueAlphaOnly.includes(e)) {
            warnSpelling = true;

            return;
        }
    });

    return (
        <div key={`selected-item_${props.name}`} className={classnames("selected-item", { "-edited": isEdited, "-warn": warnSpelling })}>
            {isEditable && (
                <div className="selected-input">
                    <div>{inputValue}</div>
                    <textarea
                        name={props.name}
                        defaultValue={text}
                        onChange={updateField}
                        onBlur={saveValue}
                        tabIndex="-1"
                        disabled={disabled}
                        maxLength={props.maxLength}
                    ></textarea>
                </div>
            )}
            {readOnlyOutput}
            {!props.disabled && (
                <button className="close" data-value={value} onClick={handleClick} tabIndex="-1" disabled={disabled}>
                    <FontAwesomeIcon icon={faTimesCircle} />
                </button>
            )}
        </div>
    );
};

SelectedItem.defaultProps = {
    spellingErrors: [],
};
